const check = /((http|https):\/\/(stage\.|medlem\.|)(matpaaminutter\.no))|^(tel|mailto|\/)/;

export function isExternalLink(href: string): boolean {
  return !check.test(href);
}
